import axios from './axios'
import * as restApi from './restMcpApi'

// REST client for Hungry MCP API
export default Object.freeze({
  axios,
  ...restApi,
})
